<kendo-grid
  #kendoGrid
  [data]="gridWrapper.gridData"
  [loading]="gridWrapper.loading"
  [height]="(bodyHeight$ | async) || 400"
  scrollable="virtual"
  rowHeight="54px"
  [skip]="gridWrapper.gridState.skip"
  [pageSize]="gridWrapper.gridState.take"
  kendoGridSelectBy="id"
  [selectedKeys]="gridWrapper.mySelection"
  [sortable]="true"
  [groupable]="true"
  [reorderable]="true"
  [resizable]="true"
  filterable="menu"
  [group]="gridWrapper.gridState.group"
  [sort]="gridWrapper.gridState.sort"
  (groupChange)="gridWrapper.groupChanged($event)"
  (dataStateChange)="gridWrapper.onDataStateChange($event)"
  (add)="addNewSp()"
  (edit)="dispatchDeepLoadSelectedItem($event, false)"
  (remove)="delete($event)"
>
  <kendo-grid-messages
    [noRecords]="gridWrapper.loading ? '' : 'Aucun résultat'"
    filterIsTrue="actif"
    filterIsFalse="inactif"
    filterClearButton="Effacer"
    filterFilterButton="Filtrer"
    groupPanelEmpty="Déplacer ici l'entête d'une colonne pour grouper..."
  >
  </kendo-grid-messages>

  <ng-template kendoGridToolbarTemplate>
    <input #mainFilter placeholder="Rechercher..." kendoTextBox (input)="gridWrapper.onFilter($event.target)" />
    <button
      mat-icon-button
      color="primary"
      [style.visibility]="mainFilter.value.length > 0 ? 'visible' : 'hidden'"
      (click)="mainFilter.value = ''; gridWrapper.clearFilter()"
    >
      <mat-icon>clear</mat-icon>
    </button>

    <button mat-mini-fab color="primary" kendoGridAddCommand matTooltip="Ajouter un SP">
      <mat-icon>add</mat-icon>
    </button>
  </ng-template>

  <kendo-grid-column field="nom" title="Nom" filterable="false"> </kendo-grid-column>
  <kendo-grid-column field="descriptionType" title="Type">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <app-multicheck-filter
        [isPrimitive]="true"
        [field]="column.field"
        [filterService]="filterService"
        [currentFilter]="filter"
        [data]="distinctPrimitive(column.field)"
      ></app-multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column editor="boolean" field="actif" title="Actif" filter="boolean" [width]="130">
    <ng-template kendoGridCellTemplate let-dataItem>
      <mat-icon [style.color]="dataItem.actif ? 'green' : 'yellow'">{{ dataItem.actif ? 'check_circle' : 'pause_circle' }}</mat-icon>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="etapesActives" title="Etapes actives" filterable="false" [width]="200"> </kendo-grid-column>

  <kendo-grid-command-column title="Actions" [width]="260" [columnMenu]="false">
    <ng-template kendoGridCellTemplate let-dataItem>
      <button *ngIf="!dataItem.actif" mat-icon-button kendoGridEditCommand matTooltip="Editer" color="primary">
        <mat-icon>edit</mat-icon>
      </button>

      <button *ngIf="!dataItem.actif" mat-icon-button kendoGridRemoveCommand matTooltip="Supprimer" color="primary">
        <mat-icon>delete</mat-icon>
      </button>

      <button
        *ngIf="existsSessionForCurrentUser$ | async"
        mat-icon-button
        matTooltip="Activation du scénario"
        (click)="toggleActivationScenario(dataItem)"
        color="primary"
      >
        <mat-icon>not_started</mat-icon>
      </button>

      <button
        *ngIf="(existsSessionForCurrentUser$ | async) && dataItem.actif"
        mat-icon-button
        matTooltip="Activation des étapes"
        (click)="toggleActivationEtapesDialog(dataItem, false)"
        color="primary"
      >
        <mat-icon>playlist_play</mat-icon>
      </button>

      <button mat-icon-button matTooltip="Détails" (click)="dispatchDeepLoadSelectedItem(dataItem, true)" color="primary">
        <mat-icon>info</mat-icon>
      </button>

      <button *ngIf="dataItem.actif" mat-icon-button matTooltip="Voir sur la carte" (click)="zoomTo($event, dataItem)" color="primary">
        <mat-icon>zoom_in</mat-icon>
      </button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>
